const FeaturesList = {
    paid_by: 1,
    loaders_available: 2,
    docks: 3,
    freight_price: 4,
    slots: 5,
    doc_invoice: 6,
    doc_eway_bill: 7,
    doc_materials: 8,
    generate_lr: 9,
    ftl_certification: 10,
    truck_inspection: 11,
    transporter_change_truck_type: 12,
    transporter_indent_action: 13,
    dispatch_notification: 14,
    cancellation_charges: 15,
    transporter_allocation: 16,
    master_material_check: 17,
    sim_tracking: 18,
    inspection_documents: 19,
    track_first_load_point: 20,
    indent_freight_charge: 21,
    indent_add_transporter: 22,
    indent_add_consignee: 23,
    indent_bulk_upload: 24,
    auto_sla_acceptance: 25,
    invoice_physical_documents: 26,
    invoice_voucher: 27,
    material_division: 28,
    erp_tool: 29,
    modified_picklist: 30,
    transporter_payment_discount: 31,
    hide_system_generated_amounts: 32,
    transit_management: 33,
    detention_combine_days: 34,
    transporter_payment_blanks: 35,
    request_for_quote: 36,
    pod_approval: 37,
    reported_at_depot: 38,
    track_loading: 39,
    epod_otp_verification: 40,
    indent_auto_cancel: 41,
    wallet: 42,
    lr_for_truck_out: 43,
    erp_send_invoice_material: 44,
    avoid_manual_material_invoice_update: 45,
    optima_auto_indent: 46,
    edit_invoice_post_invoice: 47,
    shipper_mark_as_delivered: 48,
    epod_submission: 49,
    edit_delay_damage_by_transporter: 50,
    lr_attachment_required: 51, // TODO: To be removed
    payments_v2: 52,
    pay_indents: 53,
    send_sales_mail: 54,
    optima_sob: 55,
    market_place: 56,
    consignee_wise_lr: 57,
    transporter_based_vehicles: 58,
    default_gate_selection: 59,
    invoice_two_step_approval: 60,
    track_trace: 61,
    wallet_v2: 62,
    blacklist_driver_vehicle: 63,
    auto_approve_invoice: 64,
    grn_shipper_approval: 65,
    exim: 66,
    exim_enabled: 67,
    ready_for_billing: 68,
    freight_bill: 69,
    audit_log_report: 70,
    weigh_bridge: 71,
    transporter_reports: 72,
    packing_indent: 73,
    detailed_track_view: 74,
    control_tower: 75,
    procure: 76,
    remove_movement_filter: 77,
    shipment_date_filter: 78,
    modified_picklist_report: 79,
    rate_matrix_history_report: 80,
    optima_audit_log_report: 81,
    pay_audit_log_report: 82,
    material_invoice_delivery_report: 83,
    tat_report: 84,
    truck_inspection_at_destination: 85,
    inspection_documents_at_destination: 86,
    freight_audit_process: 87,
    no_pay: 88,
    show_multidrop_in_route_ui: 89,
    capacity_utilisation_report: 90,
    indents_wo_materials_report: 91,
    indent_outlier_report: 92,
    indent_status_report: 93,
    indent_count_report: 94,
    material_invoice_freight_spent_report: 95,
    movement_data_report: 96,
    open_market_placements_report: 97,
    ops_summary_report: 98,
    optima_vs_dispatched_material_report: 99,
    optima_variance_report: 100,
    payment_compliance_report: 101,
    primary_delay_report: 102,
    secondary_delay_report: 103,
    shipment_unmapped_report: 104,
    total_distance_report: 105,
    transporter_performance_report: 106,
    unknown_materials_report: 107,
    vehicle_types_bifurcation_report: 108,
    track_and_trace_report: 109,
    optima_variance_summary_report: 110,
    optima_performance_secondary_report: 111,
    overage_shortage_damage_report: 112,
    epod_summary_report: 113,
    indent_split_combine_report: 114,
    indent_with_material_invoice_status_report: 115,
    exceptions_in_freight_provision_report: 116,
    rfq_report: 117,
    outbound_git_report: 118,
    inbound_git_report: 119,
    inbound_indent_status_report: 120,
    contract_adherence_report: 121,
    bucc_bifurcation_report: 122,
    secondary_epod_adherence: 123,
    wallet_admin_settings: 124,
    payments_v2_migrated: 125,
    delay_report: 126,
    carbon_emission_report: 127,
    direct_dispatch_variance_report: 128,
    restrict_duplicate_vehicle_assign: 129,
    autofill_vrd: 130,
    allow_shipment_number: 131,
    bulk_upload_approval_flow: 132,
    courier_booking_summary_report: 133,
    oel_fp_success_report: 134,
    pr_debit_report: 135,
    update_indents_for_back_dated_contracts: 136,
    map_driver_details_modified_picklist: 137,
    pr_debit_summary_report: 138,
    fetch_consignee_by_materials: 139,
    track_and_trace_gps_report: 140,
    invoice_custom_fields: 141,
    shortage_damage_inbound_report: 142,
    restrict_vehicle_assignment_for_type: 143,
    material_users: 144,
    update_last_dispatched_details: 145,
    modified_picklist_v2: 146,
    package_reconciliation_report: 147,
    // below feature is for a temporary fix
    consider_sold_to_in_materials: 148,
    check_route_master: 149,
    dont_recompute_expected_delivery_date_time: 150,

    marico_freight_provision_report: 151,
    depot_wise_user_summary_report: 152,
    update_materials_for_ptl: 153,
    ptl_grouping: 154,
    exception_page_landing: 155,
    exceptions_data_report: 156,
    contract_forcast_report: 157,
    lorry_receipt_client_settings: 158,
    indent_shortage_damage_report: 159,
    cost_uom_km_metrics_report: 160,
    pg_msu_truck_report: 161,
    optima_date_filter: 162,
    legal_entity_setting: 163,
    temperature_compliance_report: 164,
    restrict_multi_drop_for_ptl: 167,
    optima_savings_report: 168,
    rfq_courier_booking: 170,
    reconciliation_dedicated_truck_report: 171,
    key_based_picklist_replace: 172,
    pay_anomaly_settings: 173,
    restrict_transporter_vehicle_assignment: 174,
    restrict_past_date_in_rate_matrix: 175,
    restrict_duplicate_lr_number: 176,
    actual_dispatch_throughput_report: 177,
    future_contract_export: 178,
    allow_seal_number: 179,
    optima_auto_indent_depot_level: 180,
    view_lowest_bid: 181,
    grn_consignee_approval: 182,
    optima_calculate_material_priority: 183,
    optima_core_rerouting: 184,
    optima_sync_via_api: 185,
    optima_show_ftl_threshold: 186,
    optima_open_contract: 187,
    day_zero_service_performance_report: 188,
    // ontime_dispatch_summary_report: 189,
    // ontime_delivery_summary_report: 190,
    // delay_dispatch_summary: 191,
    // delay_delivery_summary: 192,
    last_mile: 193,
    under_utilized_vehicle_summary: 194,
    vehicle_inspection_failed_indents: 195,
    csp_booking_tracking_summary_report: 196,
    freight_invoice_status_report: 197,
    optima_combine_non_contracted_orders: 198,
    indent_with_material_bulk_upload: 199,
    vehicle_dimensions_mandatory_truck_assign: 200,
    optima_swap_sources_edit_page: 201,
    optima_last_mile: 202,
    toursolver_integration: 203,
    optima_show_ptl_threshold: 204,
    outbound_integrations_transaction: 205,
    inbound_integrations_transaction: 206,
    quicksight_role_filter: 207,
    e_invoice: 208,
    view_courier_integrations: 209,
    no_pay_for_own_fleet: 210,
    optima_create_fitment_rejection_as_open: 211,
    debit_over_credit_payment: 212,
    optima_vs_dispatched_report: 213,
    return_management: 214,
    optima_input_listing: 215,
    bin_pallet_ratio: 216,
    proforma_invoice_pdf: 217,
    view_track_details: 218,
    override_freight_while_indent_reject: 219,
    ceil_weight_volume_payment: 220,
    handling_reconciliation: 221,
    procure_dashboard_savings_calc: 222,
    procure_view_arrow_stream_conversion: 223,
    procure_view_ai_assistant: 224,
    show_lr_barcode: 225,
    max_freight_bfr_rate: 226,
    procure_ltl_menu: 227,
    ptl_sob_based_on_freight_amount: 228,
    optima_line_item_level_execution: 229,
    view_shipment_status: 230,
    view_discard_optima: 231,
    indent_listing_view_delivery_numbers: 232,
    optima_swap_destinations_edit_page: 233,
    filter_all_legal_entity_in_rfb: 234,
    report_v2: 235,
    hide_end_trip: 236,
    optima_capacity_values_need_ceil: 237,
    skip_geo_location_calculation: 238,
    optima_order_listing_show_transit_days: 239,
    add_consignee_secondary_user : 240,
    truck_weights: 241,
    show_material_category_vehicle_type_mapping: 242,
    view_contract_at_shipment_creation: 243,
    add_poc_in_indent_creation_email: 244,
    custom_invoice_approval: 245,
    reindent_acceptance: 246,
    reindent_arrival: 247,
    vahan_validation: 248,
    sarathi_validation: 249,
    pando_fms_integration: 250,
    consider_return_freight_charge: 251,
    dedicated_vehicle_number: 252,
    enable_honda_transaction_worker: 253,
    lr_attchment_rejection: 254,
    show_sob_utilization_details: 255,
    freight_provision_lrle_report: 256,
    transit_reliability_report: 257,
    detention_report: 258,
    waived_off_amount_report: 259,
    disputed_amount_transporter_report: 260,
    freight_provision_report: 261,
    csd_bifurcation_report: 262,
    freight_cost_metrics_report: 263,
    freight_provision_report: 264,
    freight_provision_report_v1: 265,
    show_indent_actions: 266,
    download_multi_e_lr: 267
  };


module.exports = {
    FeaturesList,
 };
